App.config([
    'paginationTemplateProvider',
    function(paginationTemplateProvider) {
        paginationTemplateProvider.setPath('common/views/paginationView.html');
    }
]);